import React from "react";
import PropTypes from "prop-types";

const PrimaryProgramLease = ({
  data,
  signatureData,
  staffSignatureData,
  currentDate,
}) => {
  const displayField = (value) => value || "_____________________";
  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "2440px",
        fontSize: "18px",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            display: "inline-block",
            paddingBottom: "0px",
          }}
        >
          PRIMARY PROGRAM LEASE AGREEMENT
        </h2>
      </div>

      {/* Resident Information */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>
            Resident Name:{" "}
            {displayField(
              `${data?.personalContact?.firstName || ''} ${data?.personalContact?.lastName || ''}`
            )}
          </span>
          <span>DOB: {displayField(data.personalContact.dob)}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <span>
            Admit Date: {displayField(currentDate)}
          </span>
          <span>
            Resident Home Address: {displayField(data.personalContact.address)}
          </span>
        </div>
      </div>

      {/* Bullet points section */}
      <ul
        style={{
          paddingLeft: "20px",
          listStyleType: "none",
          marginBottom: "20px",
        }}
      >
        <li style={{ marginBottom: "10px" }}>
          Recovery Residence fees are $125.00 /week. (Fees include housing and
          utilities, all scheduled programming, and program administration.)
        </li>
        <li style={{ marginBottom: "10px" }}>
          I understand that I may pay fees on a weekly, bi-weekly, or monthly
          basis. Fees are due on the 1st of each month if paying monthly. If
          paying on a weekly basis, I understand that I must pay one week ahead.
          Fees will be collected every Wednesday prior the next week.
        </li>
        <li style={{ marginBottom: "10px" }}>
          I understand that I may carry no more than a six (6) week balance on
          my account. I understand that if I fall more than six (6) weeks behind
          Legacy has the right to discharge me.
        </li>
        <li style={{ marginBottom: "10px" }}>
          I understand that I will be drug tested upon admission to Legacy.
          Thereafter, I will be drug tested periodically and randomly in
          accordance with Legacy's Drug and Alcohol Testing Policy and
          Procedure. Drug screens will be sent to a third-party laboratory for
          confirmation testing to ensure the safety of all residents and
          accuracy of screening results. These confirmatory drug tests will be
          billed by the laboratory through my insurance company in accordance
          with insurance payor guidelines. Legacy will assume all costs
          associated with point of care drug testing but is not responsible for
          fees resulting from confirmatory drug testing. Insurance companies
          often cover most of the costs for this testing, but I understand that
          I am ultimately responsible for checking with my insurance company to
          determine the extent of my coverage. The fees below are the maximum I
          can be charged for drug testing:
          <ul
            style={{
              paddingLeft: "40px",
              listStyleType: "disc",
              marginTop: "5px",
            }}
          >
            <li style={{ marginBottom: "5px" }}>G0480 Panel: $1,900.00</li>
            <li style={{ marginBottom: "5px" }}>G0481 Panel: $2,850.00</li>
            <li style={{ marginBottom: "5px" }}>G0482 Panel: $3,500.00</li>
            <li style={{ marginBottom: "5px" }}>G0483 Panel: $4,200.00</li>
            <li style={{ marginBottom: "5px" }}>
              Cash-pay clients may be charged up to $25 per point of care test
              to cover the costs.
            </li>
          </ul>
        </li>
        <li style={{ marginBottom: "10px" }}>
          Legacy utilizes Oathtrack to track housing fee payments. You must sign
          up at Oathtrack.com so you can receive a text/email reminder of
          payments due, balances as well as a secure link to pay. I understand
          that if I wish to pay by credit card, I may do so with:
          https://legacyhealing.gocashbox.com/
        </li>
        <li style={{ marginBottom: "10px" }}>
          I understand that Legacy will provide me with a receipt upon payment.
          I understand that I may request a complete record of all charges and
          payment history and Legacy will take no more than 5 business days to
          get them to me.
        </li>
      </ul>

      {/* Agreement section */}
      <div style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "10px" }}>
          I agree that I must adhere to the attached Rules and Regulations and
          make my scheduled payments when due. I further understand that failure
          to make payments when due may result in my discharge from the recovery
          residence. Any unpaid account balance at the time of discharge is
          subject to the cost of collections and lawyers' fees if required. Any
          balance remaining on a resident account, once reconciled, will be
          refunded to the resident within 10 business days after discharge from
          the recovery residence. Please note, there is a $5 convenience fee
          applicable to all such refunds.
        </p>
        <p style={{ marginBottom: "10px" }}>
          For and in consideration of services to be rendered I promise to pay
          Legacy Healing Center Margate, LLC all its charges rendered to me from
          admission to discharge. I understand that the total of such charges is
          due and payable according to this Agreement.
        </p>
      </div>

      {/* Promise to Pay section */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontWeight: "bold" }}>PROMISE TO PAY ACCOUNT</div>
        <p style={{ marginBottom: "10px" }}>
          For and in consideration of services to be rendered I severely promise
          to pay Legacy Healing Center Margate, LLC all its charges rendered to
          me from admission to discharge. I understand that the total of such
          charges are due and payable according to this FINANCIAL AGREEMENT. I
          further acknowledge that Legacy will reach out to me shall I discharge
          and carry an outstanding balance.
        </p>
      </div>

      {/* Signature line */}
      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div
            style={{
              marginBottom: "20px",
              marginTop: signatureData ? "60px" : "0",
            }}
          >
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>

      {/* Financial Agreement section */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontWeight: "bold" }}>FINANCIAL AGREEMENT</div>
        <p style={{ marginBottom: "10px" }}>
          The following constitutes the self-pay financial policy of Legacy
          Healing Center Margate, LLC hereafter called 'facility', with respect
          to services rendered at this facility.
        </p>
        <p style={{ marginBottom: "10px" }}>
          I acknowledge that I am to adhere and abide by the following:
        </p>
        <ul
          style={{
            paddingLeft: "40px",
            listStyleType: "disc",
            marginBottom: "10px",
          }}
        >
          <li style={{ marginBottom: "5px" }}>
            Rent is $125 per week (7 days)
          </li>
          <li style={{ marginBottom: "5px" }}>
            I or a paying party is responsible for all charges incurred.
          </li>
          <li style={{ marginBottom: "5px" }}>
            ROI must be completed for paying party
          </li>
          <li style={{ marginBottom: "5px" }}>All payments are due in full.</li>
          <li style={{ marginBottom: "5px" }}>
            Initial payment for treatment services is due prior to admission
          </li>
          <li style={{ marginBottom: "5px" }}>
            Subsequent payments are due on the first day of each subsequent
            week.
          </li>
          <li style={{ marginBottom: "5px" }}>
            If for any reason, the client decides to leave prior to the end of
            the billing week, all money collected will be considered
            non-refundable.
          </li>
        </ul>
        <p style={{ marginBottom: "10px" }}>
          I have provided Legacy Healing Center Margate, LLC with accurate
          financial information and have participated with the planning of this
          financial agreement. I understand that I am responsible for all my
          fees and financial obligations.
        </p>
        <p style={{ marginBottom: "10px" }}>
          I understand that my records are protected under Federal
          Confidentiality Regulations (42 U.S.C. 290dd-3 and 42 U.S.C. 290ee-3
          for Federal Laws and 42 CFR Part 2 for Federal Regulations) published
          August 10, 1997 and cannot be disclosed without written consent unless
          otherwise provided in the regulations. I understand that my medical
          records may contain information concerning my psychiatric,
          psychological, substance abuse, HIV/AIDS and or related conditions.
        </p>
        <p style={{ marginBottom: "10px" }}>
          I agree and understand the above-mentioned terms and conditions. I
          further understand that failure to adhere may result in consequences,
          curfew or dismissal from community housing.
        </p>
      </div>
    </div>
  );
};

PrimaryProgramLease.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    dob: PropTypes.string,
    admitDate: PropTypes.string,
    address: PropTypes.string,
    clientSignature: PropTypes.bool,
    signatureDate: PropTypes.string,
    // Add other expected props here
  }).isRequired,
};

export default PrimaryProgramLease;
